import { createFileRoute } from "@tanstack/react-router";
import BCBSMentalHealthCoverage from "@/pages/BCBSMentalHealthCoverage";
export const Route = createFileRoute("/bcbs-mental-health-coverage")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Mental Health Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have BCBS? Learn how mental health benefits may apply to depression, anxiety, PTSD and TMS. Check your insurance options with Neuro Wellness.",
        },
        {
          property: "og:title",
          content: "BCBS Mental Health Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have BCBS? Learn how mental health benefits may apply to depression, anxiety, PTSD and TMS. Check your insurance options with Neuro Wellness.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbs-mental-health-coverage",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbs-mental-health-coverage",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BCBSMentalHealthCoverage />;
}
